export const routes = {
  userManagement: '/user-management',
  userManagementCreate: '/user-management/create',
  userManagementEdit: '/user-management/:userId/edit',

  organization: '/organization',
  organizationCreate: '/organization/create',
  organizationEdit: '/organization/:organizationId',

  template: '/template',
  dashboard: '/',
  
  /* NRGi doesnt want this atm but says it might come back later 29-05-2026 */
  // sustainableInitiatives: '/sustainable-initiatives',
  economy: '/economy',
  contact: '/contact',
  contracts: '/contracts',
  documents: '/documents',
  eBooks: '/e-books',
  energyConsumption: '/energy-consumption',
  // news: '/blog',
  // singleNewsItem: '/blog/*',
  userInfo: '/user-info',
  // marketingMaterial: '/marketing-materials',

  callback: '/callback',

  noPermission: '/no-permission',
};

export const defaultRoute = routes.dashboard;
